<script setup lang="ts">
import { SearchOutlined } from '@ant-design/icons-vue'
import { useStaticPageStore } from '~~/stores/staticPage'

type PropTypes = {
  groupkey: string
  key: string
  label: string
  content: string
  search?: string
}
const props = withDefaults(
  defineProps<{
    questions?: PropTypes[]
  }>(),
  {
    questions: () => null
  }
)

const { questions } = toRefs(props)

const resultQuestion = ref<PropTypes[]>(questions.value)
const search = ref(null)
const showList = ref(false)
const searchbarRef = ref(null)

const route = useRoute()

useClickOutside(searchbarRef, () => {
  showList.value = false
  search.value = null
})

const triggerSearch = (event) => {
  const value = event?.target?.value
  if (value.length >= 3) {
    showList.value = true
    resultQuestion.value = questions.value
      ?.filter((question) =>
        question?.label.toLowerCase().includes(value.toLowerCase())
      )
      .map((sentence) => {
        return {
          ...sentence,
          search: sentence?.label.replace(new RegExp(value, 'gi'), '<b>$&</b>')
        }
      })
  } else {
    showList.value = false
  }
}
const staticPageStore = useStaticPageStore()

const onClickMenu = (menu) => {
  staticPageStore.setActiveQuestion({
    groupKey: menu?.groupkey,
    questionActive: {
      key: menu.key,
      label: menu.label,
      content: menu.content
    }
  })

  showList.value = false
  search.value = null
}
</script>

<template>
  <div :class="['pusat-bantuan__banner', route?.query ? 'detail' : null]">
    <h4 v-if="!route.query" class="banner-title">Apa yang bisa kami bantu?</h4>
    <div class="banner-search">
      <a-input
        v-model:value="search"
        placeholder="Cari artikel bantuan..."
        allow-clear
        size="large"
        @change="triggerSearch"
      >
        <template #prefix>
          <SearchOutlined />
        </template>
      </a-input>

      <ul v-if="showList" ref="ssearchbarRefea" class="banner-search__collapse">
        <li v-if="isEmpty(resultQuestion)">
          <AtomsEmpty description="Hasil pencarian tidak ditemukan" />
        </li>
        <li
          v-for="question in resultQuestion"
          v-else
          :key="question.key"
          @click="onClickMenu(question)"
        >
          <div v-html="question?.search ?? question.label"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
@use './styles.scss';
</style>
